export const ActionTypes = {
  APPLICATION_BE_REQUEST: 'APPLICATION_BE_REQUEST',
  APPLICATION_BE_REQUEST_RESET: 'APPLICATION_BE_REQUEST_RESET',
  APPLICATION_BE_REQUEST_COMPLETED: 'APPLICATION_BE_REQUEST_COMPLETED',
  APPLICATION_USER_CREDENTIALS_CLEAR: 'APPLICATION_USER_CREDENTIALS_CLEAR',
  APPLICATION_USER_CREDENTIALS_SET: 'APPLICATION_USER_CREDENTIALS_SET',
  APPLICATION_USER_CREDENTIALS_REFRESH: 'APPLICATION_USER_CREDENTIALS_REFRESH',
  APPLICATION_FOLDER_SELECT: 'APPLICATION_FOLDER_SELECT',
  APPLICATION_FOLDER_CREATE: 'APPLICATION_FOLDER_CREATE',
  APPLICATION_FOLDER_RENAME: 'APPLICATION_FOLDER_RENAME',
  APPLICATION_FOLDER_RENAME_OK: 'APPLICATION_FOLDER_RENAME_OK',
  APPLICATION_MESSAGE_FILTER_SET: 'APPLICATION_MESSAGE_FILTER_SET',
  APPLICATION_MESSAGE_FILTER_KEYWORD_SET:
    'APPLICATION_MESSAGE_FILTER_KEYWORD_SET',
  APPLICATION_EVENT_FILTER_KEYWORD_SET: 'APPLICATION_EVENT_FILTER_KEYWORD_SET',
  APPLICATION_SHOW_FILTER_EVENT_FIELDS: 'APPLICATION_SHOW_FILTER_EVENT_FIELDS',
  APPLICATION_IS_FILTER_DATE: 'APPLICATION_IS_FILTER_DATE',
  APPLICATION_MESSAGE_FILTER_MESSAGES_SET: 'APPLICATION_MESSAGE_FILTER_MESSAGES_SET',
  APPLICATION_IS_SEARCH_TOP_BAR: 'APPLICATION_IS_SEARCH_TOP_BAR',
  APPLICATION_MESSAGE_EDIT: 'APPLICATION_MESSAGE_EDIT',
  APPLICATION_MESSAGE_SELECT: 'APPLICATION_MESSAGE_SELECT',
  APPLICATION_MESSAGE_REFRESH: 'APPLICATION_MESSAGE_REFRESH',
  APPLICATION_MESSAGE_REFRESH_BE_REQUEST:
    'APPLICATION_MESSAGE_REFRESH_BE_REQUEST',
  APPLICATION_MESSAGE_REFRESH_BE_REQUEST_RESET:
    'APPLICATION_MESSAGE_REFRESH_BE_REQUEST_RESET',
  APPLICATION_MESSAGE_REFRESH_BE_REQUEST_COMPLETED:
    'APPLICATION_MESSAGE_REFRESH_BE_REQUEST_COMPLETED',
  APPLICATION_MESSAGE_PRE_DOWNLOAD: 'APPLICATION_MESSAGE_PRE_DOWNLOAD',
  APPLICATION_MESSAGE_REPLACE_IMAGE: 'APPLICATION_MESSAGE_REPLACE_IMAGE',
  APPLICATION_MESSAGE_REPLACE_IMAGE_BASE64:
    'APPLICATION_MESSAGE_REPLACE_IMAGE_BASE64',
  APPLICATION_OUTBOX_SEND: 'APPLICATION_OUTBOX_SEND',
  APPLICATION_OUTBOX_UPDATE_PROGRESS: 'APPLICATION_OUTBOX_UPDATE_PROGRESS',
  APPLICATION_DRAFT_UPDATE_PROGRESS: 'APPLICATION_DRAFT_UPDATE_PROGRESS',
  APPLICATION_OUTBOX_SET_SENT: 'APPLICATION_OUTBOX_SET_SENT',
  APPLICATION_DRAFT_SET_SENT: 'APPLICATION_DRAFT_SET_SENT',
  APPLICATION_OUTBOX_SET_ERROR: 'APPLICATION_OUTBOX_SET_ERROR',
  APPLICATION_DRAFT_SET_ERROR: 'APPLICATION_DRAFT_SET_ERROR',
  APPLICATION_OUTBOX_MESSAGE_PROCESSED: 'APPLICATION_OUTBOX_MESSAGE_PROCESSED',
  APPLICATION_DRAFT_CLEAN: 'APPLICATION_DRAFT_CLEAN',
  APPLICATION_OUTBOX_EVENT_NOTIFIED: 'APPLICATION_OUTBOX_EVENT_NOTIFIED',
  APPLICATION_ERROR_SET: 'APPLICATION_ERROR_SET',
  APPLICATION_NEXTCLOUD_USER: 'APPLICATION_NEXTCLOUD_USER',
  APPLICATION_SERVICE: 'APPLICATION_SERVICE',
  APPLICATION_CUSTOMER_CONNECT_EMAIL: 'APPLICATION_CUSTOMER_CONNECT_EMAIL',
  FOLDERS_BE_REQUEST: 'FOLDERS_BE_REQUEST',
  FOLDERS_BE_REQUEST_RESET: 'FOLDERS_BE_REQUEST_RESET',
  FOLDERS_SET_SHOW_FOLDER_LIST: 'FOLDERS_SET_SHOW_FOLDER_LIST',
  FOLDERS_SET: 'FOLDERS_SET',
  SET_FIRST_SYNC_IMAP: 'SET_FIRST_SYNC_IMAP',
  FOLDERS_UPDATE: 'FOLDERS_UPDATE',
  FOLDERS_UPDATE_PARENT_ONLY: 'FOLDERS_UPDATE_PARENT_ONLY',
  FOLDERS_SET_SHOW_MOVE_FOLDER_ALERT: 'FOLDERS_SET_SHOW_MOVE_FOLDER_ALERT',
  LOGIN_FORM_VALUES_SET: 'LOGIN_FORM_VALUES_SET',
  MESSAGES_BE_REQUEST: 'MESSAGES_BE_REQUEST',
  MESSAGES_BE_REQUEST_RESET: 'MESSAGES_BE_REQUEST_RESET',
  MESSAGES_BE_REQUEST_COMPLETED: 'MESSAGES_BE_REQUEST_COMPLETED',
  MESSAGES_SET_CACHE: 'MESSAGES_SET_CACHE',
  MESSAGES_SET_FOLDER_CACHE: 'MESSAGES_SET_FOLDER_CACHE',
  MESSAGES_UPDATE_CACHE: 'MESSAGES_UPDATE_CACHE',
  MESSAGES_UPDATE_CACHE_IF_EXIST: 'MESSAGES_UPDATE_CACHE_IF_EXIST',
  MESSAGES_DELETE_FROM_CACHE: 'MESSAGES_DELETE_FROM_CACHE',
  MESSAGES_RENAME_CACHE: 'MESSAGES_RENAME_CACHE',
  MESSAGES_SET_SELECTED: 'MESSAGES_SET_SELECTED',
  ADD_MESSAGE_CLASSIFICATION: 'ADD_MESSAGE_CLASSIFICATION',
  MESSAGES_CLEAR_SELECTED: 'MESSAGES_CLEAR_SELECTED',
  MESSAGES_CLEAR_OPENED_AND_RECOVER_SELECTED:
    'MESSAGES_CLEAR_OPENED_AND_RECOVER_SELECTED',
  MESSAGES_LOCK_ADD: 'MESSAGES_LOCK_ADD',
  MESSAGES_LOCK_REMOVE: 'MESSAGES_LOCK_REMOVE',
  LEXON_USER: 'LEXON_USER',
  LEXON_CASEFILE: 'LEXON_CASEFILE',
  LEXON_DATABASE: 'LEXON_DATABASE',
  LEXON_EMAIL: 'LEXON_EMAIL',
  LEXON_EMAIL_SET_SHOWN: 'LEXON_EMAIL_SET_SHOWN',
  LEXON_ACCOUNT: 'LEXON_ACCOUNT',
  LEXON_RESET_EMAIL: 'LEXON_RESET_EMAIL',
  LEXON_MAILCONTACTS: 'LEXON_MAILCONTACTS',
  LEXON_DOCUMENTS_ID: 'LEXON_DOCUMENTS_ID',
  LEXON_ACCOUNT_GUID: 'LEXON_ACCOUNT_GUID',
  LEXON_ACCOUNT_SIGN: 'LEXON_ACCOUNT_SIGN',
  LEXON_ACCOUNT_FIRMAS: 'LEXON_ACCOUNT_FIRMAS',
  LEXON_ACCOUNT_TEMPLATES: 'LEXON_ACCOUNT_TEMPLATES',
  LEXON_ACCOUNT_FOLDERS: 'LEXON_ACCOUNT_FOLDERS',
  LEXON_IDMAIL: 'LEXON_IDMAIL',
  LEXON_TOKEN: 'LEXON_TOKEN',
  TOKEN_WITHOUT_DOCUMENT: 'TOKEN_WITHOUT_DOCUMENT',
  LEXON_IDACTUATION: 'LEXON_IDACTUATION',
  LEXON_IDEVENT: 'LEXON_IDEVENT',
  LEXON_NEW_IDACTUATION: 'LEXON_NEW_IDACTUATION',
  LEXON_NEW_IDEVENT: 'LEXON_NEW_IDEVENT',
  LEXON_TITLE: 'LEXON_TITLE',
  LEXON_RESET_IDACTUATION: 'LEXON_RESET_IDACTUATION',
  LEXON_RESET_IDEVENT: 'LEXON_RESET_IDEVENT',
  LEXON_IDCALENDAR: 'LEXON_IDCALENDAR',
  LEXON_FIRST_LOAD: 'LEXON_FIRST_LOAD',
  LEXON_ID_CLIENT_LEF: 'LEXON_ID_CLIENT_LEF',
  TOKEN: 'TOKEN',
  LEXON_CONFIG_CALENDAR: 'LEXON_CONFIG_CALENDAR',
  LEXON_APP_CONNECT: 'LEXON_APP_CONNECT',
  SET_ID_RESPONSABLE: 'SET_ID_RESPONSABLE',
  APPLICATION_INVALID_AUTH: 'APPLICATION_INVALID_AUTH',
  LEXON_CREDENTIALS_CLEAR: 'LEXON_CREDENTIALS_CLEAR',
  SET_DOCUMENT_TOKEN: 'SET_DOCUMENT_TOKEN',
  APPLICATION_SHOW_SETTINGS_POPOVER: 'APPLICATION_SHOW_SETTINGS_POPOVER',
  APPLICATION_MESSAGE_FILTER_MESSAGES_LOADING: 'APPLICATION_MESSAGE_FILTER_MESSAGES_LOADING',
  APPLICATION_SHOW_FILTER_SEARCH: 'APPLICATION_SHOW_FILTER_SEARCH',
  APPLICATION_SHOW_USER_SIGN_POPOVER: 'APPLICATION_SHOW_USER_SIGN_POPOVER',
  APPLICATION_SHOW_USER_TEMPLATE_POPOVER: 'APPLICATION_SHOW_USER_TEMPLATE_POPOVER',
  APPLICATION_SHOW_DEFAULT_CALENDAR_POPOVER: 'APPLICATION_SHOW_DEFAULT_CALENDAR_POPOVER',
  SET_SIDEBAR_OPEN_LEXON: "SET_SIDEBAR_OPEN_LEXON",
  SET_SIDEBAR_OPEN_CALENDAR: "SET_SIDEBAR_OPEN_CALENDAR",
  SET_SIDEBAR_OPEN_CENTINELA: "SET_SIDEBAR_OPEN_CENTINELA",
  SET_SIDEBAR_OPEN_DATABASE: "SET_SIDEBAR_OPEN_DATABASE",
  LEXON_INTERVENERS: "LEXON_INTERVENERS",
  LEXON_SUBJECT_EMAIL: 'LEXON_SUBJECT_EMAIL',
  LEXON_IS_COMPOSE: 'LEXON_IS_COMPOSE',
  NEXTCLOUD_ACCOUNT_AUTH: 'NEXTCLOUD_ACCOUNT_AUTH',
  FOLDERS_SET_IS_UPDATED_FOLDER: 'FOLDERS_SET_IS_UPDATED_FOLDER',
  APPLICATION_SHOW_PREVIEW: 'APPLICATION_SHOW_PREVIEW',
  SET_IS_FULL_MESSAGE_CONTENT: 'SET_IS_FULL_MESSAGE_CONTENT',
  APPLICATION_CLEAR_FILTERED_MESSAGES: 'APPLICATION_CLEAR_FILTERED_MESSAGES',
  APPLICATION_ERROR_CLEAR: 'APPLICATION_ERROR_CLEAR',
  MESSAGES_SET_FILTERS_APPLIED: 'MESSAGES_SET_FILTERS_APPLIED',
  MESSAGES_APPEND_FILTERED_MESSAGES: 'MESSAGES_APPEND_FILTERED_MESSAGES',
  MESSAGES_CLEAR_FILTERED_MESSAGES: 'MESSAGES_CLEAR_FILTERED_MESSAGES'
};
